import Tabs from "../tabs";
import { useState } from "react";
import {
  Stepper,
  Step,
  StepLabel, Box,
  Typography, StepConnector, Stack, Button, stepConnectorClasses,
  Grid, Radio,
  RadioGroup,
  FormControlLabel,
  Divider, TextField
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SingleSelect from "../../../../components/selections/singleSelect";
import SnackbarMessage from "../../../../components/snackBar/snackBar";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckIcon from "@mui/icons-material/Check";

const departments = [
  { value: 1, label: "Cardiology" },
  { value: 2, label: "Neurology" },
  { value: 3, label: "Orthopedics" },
];

const specializations = [
  { value: 1, departmentId: 1, label: "Interventional Cardiology" },
  { value: 2, departmentId: 1, label: "Pediatric Cardiology" },
  { value: 3, departmentId: 2, label: "Neuro Surgery" },
  { value: 4, departmentId: 2, label: "Clinical Neurology" },
  { value: 5, departmentId: 3, label: "Joint Replacement" },
];

const doctorDetails = [
  { value: 1, label: "Sumit" },
  { value: 2, label: "Ramesh" },
];

const SLOT_OPTIONS = [
  { value: 1, label: "09:00 AM - 10:00 AM", },
  { value: 2, label: "10:00 AM - 11:00 AM", },
  { value: 3, label: "11:00 AM - 12:00 PM", }
];


const exitAndNewUserDetails = [
  { value: 1, label: "New User" },
  { value: 2, label: "Existing User" },
];

const RELATION_OPTIONS = [
  { value: "self", label: "Self" },
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
  { value: "spouse", label: "Spouse" },
  { value: "son", label: "Son" },
  { value: "daughter", label: "Daughter" },
  { value: "brother", label: "Brother" },
  { value: "sister", label: "Sister" },
  { value: "grandfather", label: "Grandfather" },
  { value: "grandmother", label: "Grandmother" },
];

const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];


const PurpleConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#9c27b0",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#9c27b0",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.grey[400],
    borderRadius: 1,
  },
}));


const StepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor: ownerState.active || ownerState.completed
    ? "#9c27b0"
    : "#ffffff",
  zIndex: 1,
  border: ownerState.active || ownerState.completed
    ? "2px solid #9c27b0"
    : "2px solid #bdbdbd",
  color: ownerState.active || ownerState.completed ? "#fff" : "#9e9e9e",
  width: 50,
  height: 50,
  alignItems: "center",
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
}));


function CustomStepIcon(props) {
  const { active, completed, icon } = props;
  const icons = {
    1: <MedicalServicesIcon />,
    2: <AccessTimeIcon />,
    3: <AssignmentIcon />,
    4: <CheckIcon />,
  };

  return (
    <StepIconRoot ownerState={{ active, completed }}>
      {icons[String(icon)]}
    </StepIconRoot>
  );
}

function AppointmentCreation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getContacts } = useSelector((state) => state.contacts);

  const [state, setState] = useState({
    activeStep: 0,
    steps: ["Select Department /Doctor", "Select Slot", "Personal Details", "Confirmation"],
    selectedDepartmentValue: "",
    selectedSpecializationValue: "",
    selectedDoctorValue: "",
    errors: {},
    selectedAppointmentDate: dayjs(),
    selectedAppointmentSlot: "",
    selectExitAndNewUserOption: 1,
    selectUserValue: "",
    relationType: "",
    relationName: "",
    relationMobile: "",
    relationGender: "",
    relationAge: "",
    relativeComments: "",
    selectExistingUserId: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const { activeStep, steps, selectedDepartmentValue, selectedSpecializationValue, selectedDoctorValue, selectedAppointmentDate, selectedAppointmentSlot, errors, selectExitAndNewUserOption, selectUserValue, relationType, relationName,
    relationMobile, selectExistingUserId,
    relationGender, relativeComments,
    relationAge, } = state;

  const styles = {
    border: "none",
    borderRadius: "8px",
    px: 3,
    py: 1,
    "&.Mui-disabled": {
      cursor: "not-allowed",          // ✅ force not-allowed cursor
      opacity: 0.7,                   // optional visual cue
      color: "var(--light-bg)",       // keep text same
    },
  };

  const handleNext = async (e) => {
    e.preventDefault();
    let extraValidations = [];

    if (activeStep === 0) {
      extraValidations = [
        { valid: selectedDepartmentValue, field: "selectedDepartmentValue", message: "Please select department" },
        { valid: selectedSpecializationValue, field: "selectedSpecializationValue", message: "Please select specialization" },
        { valid: selectedDoctorValue, field: "selectedDoctorValue", message: "Please select Doctor" },
      ];
    } else if (activeStep === 1) {
      extraValidations = [
        { valid: selectedAppointmentDate, field: "selectedAppointmentDate", message: "Please select Date" },
        { valid: selectedAppointmentSlot, field: "selectedAppointmentSlot", message: "Please select slot" },
      ];
    } else if (activeStep === 2) {
      extraValidations = [
        ...selectExitAndNewUserOption !== 1 ? [{ valid: selectExistingUserId, field: "selectExistingUserId", message: "Please select User", },] :
          [{ valid: selectUserValue, field: "selectUserValue", message: "Please select User", },],
        { valid: relationType, field: "relationType", message: "Please select relation", },
        { valid: relationName, field: "relationName", message: "Please enter relation name", },
        { valid: relationMobile && relationMobile.length === 10, field: "relationMobile", message: "Please enter valid 10 digit mobile number", },
        { valid: relationGender, field: "relationGender", message: "Please select gender", },
        { valid: relationAge && Number(relationAge) > 0, field: "relationAge", message: "Please enter valid age", },
      ];

    }

    for (let rule of extraValidations) {
      if (!rule.valid) {
        setSnackbar({ open: true, message: rule.message, severity: "error" });
        setState((prev) => ({ ...prev, errors: { ...prev.errors, [rule.field]: rule.message } }));
        return;
      }
    }

    setState((prev) => ({
      ...prev,
      activeStep: prev.activeStep + 1,
    }));
  };

  const handleBack = () => {
    setState((prev) => ({
      ...prev,
      activeStep: Math.max(prev.activeStep - 1, 0),
    }));
  };

  const handleSingleSelectChange = (name, selectedValue) => {
    setState((prev) => ({
      ...prev,
      [name]: selectedValue,
      errors: { ...prev.errors, [name]: "" },
    }));
  };

  const handleExitAndNewUserChange = (value) => {
    setState((prev) => ({
      ...prev,
      selectExitAndNewUserOption: value,
      errors: {}
    }));
  };

  const handleChange = (name, value) => {
    let newValue = value;

    if (name === "relationName") {
      newValue = value.replace(/^\s+/, "").slice(0, 30);
    } else if (name === "relationMobile") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    } else if (name === "relationAge") {
      newValue = value.replace(/\D/g, "").slice(0, 3);
    }

    setState((prev) => ({
      ...prev,
      [name]: newValue,
      errors: { ...prev.errors, [name]: "" },
    }));
  };



  return (
    <div>
      <Tabs />

      <Box mt={3}>
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          connector={<PurpleConnector />}
        >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                StepIconComponent={CustomStepIcon}
                sx={{
                  "& .MuiStepLabel-label": {
                    mt: 1,
                    fontWeight: 500,
                    color:
                      index <= activeStep ? "#9c27b0" : "#9e9e9e",
                  },
                }}
              >
                <Typography fontSize={14}>{label}</Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      <Box p={2} mt={2}>
        <Grid container spacing={1}>
          {
            activeStep === 0 ? (
              <>
                {
                  [{ id: 1, name: "selectedDepartmentValue", value: selectedDepartmentValue, options: departments, label: "Select Departments" },
                  { id: 2, name: "selectedSpecializationValue", value: selectedSpecializationValue, options: specializations.filter((item) => item.departmentId === selectedDepartmentValue), label: "Select Specializations" },
                  { id: 3, name: "selectedDoctorValue", value: selectedDoctorValue, options: doctorDetails, label: "Select Doctor" },].map((field) => (
                    <Grid item size={{ xs: 12, md: 4 }}>
                      <SingleSelect
                        key={field.id}
                        name={field.name}
                        label={field.label}
                        options={field.options}
                        value={field.value}
                        onChange={handleSingleSelectChange}
                        error={!!state.errors?.[field.name]}
                        formHelperText={false}
                      />
                    </Grid>
                  ))
                }
              </>
            ) : activeStep === 1 ? (
              <>
                <Grid item size={{ xs: 12, md: 4 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      disablePast
                      label="Next Visit Date"
                      value={selectedAppointmentDate}
                      onChange={(newValue) =>
                        setState((prev) => ({
                          ...prev,
                          selectedAppointmentDate: newValue,
                          errors: { ...prev.errors, selectedAppointmentDate: "" },
                        }))
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          error: !!errors.selectedAppointmentDate,
                        },
                        openPickerButton: {
                          sx: {
                            color: "green",
                            "& svg": {
                              fontSize: "32px", // 👈 icon size
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                  <SingleSelect
                    label="Slot Name"
                    name="selectedAppointmentSlot"
                    options={SLOT_OPTIONS}
                    value={selectedAppointmentSlot}
                    onChange={(name, value) =>
                      setState((prev) => ({
                        ...prev,
                        selectedAppointmentSlot: value,
                        errors: { ...prev.errors, selectedAppointmentSlot: "" },
                      }))
                    }
                    error={!!state.errors.selectedAppointmentSlot}
                  />
                </Grid>
              </>) : activeStep === 2 ? (
                <Box
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    border: "1px solid #e0e0e0",
                    overflow: "hidden",
                    bgcolor: "#fff",
                  }}
                >
                  {/* 🔹 Header */}
                  <Box
                    sx={{
                      px: 2,
                      py: 1,
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                  >
                    <Grid container spacing={1}>
                      <Grid item size={{ xs: 12, md: 12 }}>
                        <RadioGroup
                          row
                          value={selectExitAndNewUserOption}
                          onChange={(e) => handleExitAndNewUserChange(e.target.value)}
                        >
                          {exitAndNewUserDetails.map((option) => (
                            <FormControlLabel
                              key={option.value}
                              value={option.value}
                              control={<Radio />}
                              label={option.label}
                              sx={{ mr: 2 }}
                            />
                          ))}
                        </RadioGroup>
                      </Grid>
                    </Grid>
                  </Box>
                  <Divider />

                  {/* 🔹 Body */}
                  <Grid container spacing={1} mt={2} mb={2} p={1}>
                    {
                      [
                        ...+selectExitAndNewUserOption !== 1 ? [
                          { id: 1, value: selectExistingUserId, name: "selectExistingUserId", type: "select", label: "Select Existing User", options: Array.isArray(getContacts) ? getContacts.map((item) => ({ value: item.id, label: `${item.name} (${item.mobile})` })) : [] }
                        ] : [
                          { id: 2, value: selectUserValue, name: "selectUserValue", type: "select", label: "Select User", options: Array.isArray(getContacts) ? getContacts.map((item) => ({ value: item.id, label: `${item.name} (${item.mobile})` })) : [] },
                        ],
                        { id: 3, value: relationType, name: "relationType", type: "select", label: "Select Relation", options: RELATION_OPTIONS },
                        { id: 4, value: relationName, name: "relationName", type: "text", label: "Enter Relation Name" },
                        { id: 5, value: relationMobile, name: "relationMobile", type: "text", label: "Enter Mobile Number" },
                        { id: 6, value: relationGender, name: "relationGender", type: "select", label: "Select Gender", options: GENDER_OPTIONS },
                        { id: 7, value: relationAge, name: "relationAge", type: "text", label: "Enter Age" },
                        { id: 8, value: relativeComments, name: "relativeComments", type: "text", label: "Enter Comments" },
                      ].map((field) => (
                        <Grid item size={{ xs: 12, md: field.id === 8 ? 12 : 4 }} key={field.id} sx={{ mb: 1 }}>
                          {field.type === "select" ? (
                            <SingleSelect
                              name={field.name}
                              label={field.label}
                              options={field.options}
                              value={field.value}
                              onChange={handleSingleSelectChange}
                              error={!!state.errors[field.name]}
                              formHelperText={false}
                            />
                          ) : (
                            <TextField
                              multiline
                              fullWidth
                              minRows={field.id === 8 && 3}
                              maxRows={field.id === 8 && 3}
                              size="small"
                              label={field.label}
                              value={state[field.name]}
                              onChange={(e) => handleChange(field.name, e.target.value)}
                              error={!!state.errors[field.name]}
                              inputProps={{
                                ...(field.name === "relationMobile" && {
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  maxLength: 10,
                                }),
                                ...(field.name === "relationAge" && {
                                  inputMode: "numeric",
                                  maxLength: 3,
                                }),
                              }}
                            />
                          )}
                        </Grid>
                      ))
                    }
                  </Grid>
                </Box>
              ) : (
              <Box
                sx={{
                  width: "100%",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  overflow: "hidden",
                  bgcolor: "#fff",
                }}
              >
                {/* 🔹 Header */}
                <Box
                  sx={{
                    px: 2,
                    py: 1,
                    color: "#000",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Typography variant="h6">
                      Appointment Summary
                    </Typography>

                    <Button variant="outlined" size="small">
                      Download Pdf
                    </Button>
                  </Box>
                  <Divider />
                  <Grid container spacing={1} mt={1}>
                    {
                      [
                        {
                          label: "Department", value: departments.find(
                            (item) => item.value === selectedDepartmentValue
                          )?.label || "-"
                        },

                        {
                          label: "Specialization", value: specializations.find(
                            (item) => item.value === selectedSpecializationValue
                          )?.label || "-"
                        },
                        {
                          label: "Doctor", value: doctorDetails.find(
                            (item) => item.value === selectedDoctorValue
                          )?.label || "-"
                        },
                        { label: "Appointment Date", value: selectedAppointmentDate ? dayjs(selectedAppointmentDate).format("DD MMM YYYY") : "-" },
                        {
                          label: "Appointment Slot", value: SLOT_OPTIONS.find(
                            (item) => item.value === selectedAppointmentSlot
                          )?.label || "-"
                        },
                        {
                          label: "User Type",
                          value: +selectExitAndNewUserOption === 1 ? "Existing User" : "New User",
                        },
                        {
                          label: "Existing User",
                          value:
                            +selectExitAndNewUserOption === 1
                              ? getContacts.find(
                                (item) => item.id === selectExistingUserId
                              )?.name || "N/A"
                              : "N/A",
                        },
                        { label: "Relation Type", value: relationType?.label || "-" },
                        { label: "Relation Name", value: relationName || "-" },
                        { label: "Relation Mobile", value: relationMobile || "-" },
                        { label: "Gender", value: relationGender?.label || "-" },
                        { label: "Age", value: relationAge || "-" },
                        { label: "Comments", value: relativeComments || "-" },
                      ].map((item, index) => (
                        <Grid item size={{ xs: 12, md: 6 }} key={index}>
                          <Box display="flex">
                            <Typography sx={{ fontWeight: 600, mr: 1 }}>
                              {item.label}:
                            </Typography>
                            <Typography color="text.secondary">
                              {item.value}
                            </Typography>
                          </Box>
                        </Grid>
                      ))
                    }
                  </Grid>
                </Box>
              </Box>
            )
          }
        </Grid>
      </Box>


      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
        <div style={{ cursor: activeStep === 0 ? "not-allowed" : "pointer" }}>
          <Button disabled={activeStep === 0} variant="outlined" onClick={handleBack}
            sx={{
              ...styles,
              background: "var(--disabled-color)",
              color: "#000",
              "&:hover": {
                background: "var(--primary)",
                color: "#fff"
              },
              "&.Mui-disabled": {
                cursor: "not-allowed",          // ✅ force not-allowed cursor
                opacity: 0.7,                   // optional visual cue
                color: "#000",       // keep text same
              },
            }}>
            Back
          </Button>
        </div>
        <Button
          variant="contained"
          color="primary"
          disabled={activeStep >= 3}
          onClick={handleNext}
          sx={{ ...styles, background: "var(--primary)", color: "var(--light-bg)", }}
        >
          Next
        </Button>
      </Stack>

      <SnackbarMessage
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />
    </div>
  );
};
export default AppointmentCreation;